// extracted by mini-css-extract-plugin
module.exports = {"layersCollapse":"style_layersCollapse__3ovTy","collapse":"style_collapse__bdIoM","title":"style_title__llfqO","layersBtn":"style_layersBtn__3NW0O"};